import React from 'react';
import { IView } from 'interfaces/common';
import { IRoles } from 'interfaces/roles.interface';

const OnboardingDetailsUserView: IView = {
  key: 'viewOnboardingPreviewUser',
  title: 'preonboardingTemplateUser.previewUserView.title',
  roles: [IRoles.ADMINISTRATOR, IRoles.HR, IRoles.SUPERIOR],
  view: React.lazy(() => import('./view-template-user')),
  path: ['/podglad-szablonu/:userId'],
};

export default OnboardingDetailsUserView;
